import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  /**
   *
   * @param value
   * @returns string with nbsp; replaced with [space]
   * this resolves an issue where strings joined by nbsp;
   * are overflowing the parent card
   */
  public normalizeSpaces(value: string): string {
    if (typeof value != 'string' || !value) {
      return value;
    }
    return value.replace(/(&nbsp;|&#160;|\u00A0)/g, ' ').trim();
  }
}
